import Instant from './InstantComponent';

export default Instant;